'use client';

import classnames from 'classnames';
import {default as Image} from '@/components/global/images/resized-cdn-image';
import { useParams } from 'next/navigation';
import React from 'react';

import { doTranslation } from '@/app/i18n/client';
import styles from '@/components/bus-station/bus-station-hours.module.scss';
import Pill from '@/components/global/pills/pill';
import time from '@/public/assets/images/global/bus-station/time.svg';

type Props = {
  hours?: boolean;
  heading?: string;
  days?: any;
  stateCode?: string;
  stationName?: string;
};

const BusStationHours = (props: Props): React.JSX.Element => {
  const { lng }: any = useParams();
  const { t } = doTranslation(lng);

  const { hours, heading, days, stateCode, stationName } = props;

  const renderHoursNotice = () => {
    return (
      <div className={styles.text}>
        {(!days || !Object.keys(days).length) && !hours && (
          <div
            dangerouslySetInnerHTML={{
              __html: t('{{- stationName }}, {{ stateCode }} hours are not available at this time.', {
                stationName,
                stateCode
              })
            }}
          ></div>
        )}
        {t(
          'Terminal Hours are subject to change without notice. To verify hours that tickets are sold, please call the terminal or contact '
        )}
        <a
          className={`${styles.link} gtm-customer_care`}
          href={`${process.env.NEXT_PUBLIC_TRAILWAYS_SITE_BASE}/contacts/`}
          target="_blank"
        >
          {t('Customer Care')}.
        </a>
      </div>
    );
  };

  return (
    <div className={styles.card}>
      <div
        className={classnames({
          [styles.header]: true,
          [styles.hours]: hours
        })}
      >
        <div className={styles.title}>
          <Image alt={t('Time')} height="36" src={time} width="36" />
          <h2 className={styles.text}>{heading}</h2>
        </div>
        {hours && <Pill label={t('Open 24 Hours')}></Pill>}
      </div>
      {hours ? (
        <div className={styles.body}>{renderHoursNotice()}</div>
      ) : days && Object.keys(days).length ? (
        <dl className={styles.body}>
          {Object.entries(days).map((dayInfo: any) => (
            <div className={styles.row} key={dayInfo[0]}>
              <dt className={styles.day}>{t(dayInfo[0])}</dt>
              <dd className={styles.col}>
                {dayInfo[1].map((hour: any, index: number) => (
                  <div className={styles.time} key={`${dayInfo[0]}-${index}`}>
                    <div>{hour.time}</div>
                    <div className={styles.note}>{hour.note}</div>
                  </div>
                ))}
              </dd>
            </div>
          ))}
          {renderHoursNotice()}
        </dl>
      ) : (
        <div className={styles.body}>{renderHoursNotice()}</div>
      )}
    </div>
  );
};

export default BusStationHours;
